<!-- eslint-disable vue/html-self-closing -->
<template>
  <div
    class="d-flex discussion__item"
    :class="{ '--hidden': commentIsDeleted }"
  >
    <div class="pr-3 d-none d-sm-block">
      <a :href="'/user/' + discussion.author.username">
        <img
          :src="discussion.author.avatar"
          class="rounded-circle"
          height="40px"
          width="40px"
        />
      </a>
    </div>
    <div class="card mb-3 w-100">
      <div class="card-header bg-light py-2 d-flex align-items-center">
        <div class="flex-grow-1 text-truncate">
          <a
            :href="'/user/' + discussion.author.username"
            class="text-body f5"
          >
            <span class="font-weight-bolder">{{ discussion.author.fullName }}</span>
            <span class="mr-1 text-muted text-decoration-none">
              @{{ discussion.author.username }}
            </span>
          </a>
          <span class="f6 text-muted">
            {{ $tc('message.comment', 2) }}
          </span>
          <span class="f6 text-muted">
            {{ $moment.utc(discussion.createdAt).fromNow() }}
          </span>
        </div>
        <button
          v-if="hasEditPermission"
          type="button"
          class="d-flex align-items-center discussion__item-btn btn btn-link text-dark float-right mr-2"
          @click="editComment"
        >
          <i class="gf-icon gf-icon-pen" />
        </button>
        <button
          v-if="hasDelete"
          type="button"
          class="d-flex align-items-center discussion__item-btn btn btn-link text-danger float-right"
          :disabled="commentIsDeleted"
          @click="deleteComment"
        >
          <i class=" gf-icon gf-icon-trash" />
        </button>
      </div>
      <div class="card-body break-word">
        <div
          v-if="!hasEdit"
          ref="discussionText"
          class="markdown-body break-word"
          v-html="discussion.message"
        />
        <div v-else>
          <gf-custom-text-editor
            ref="issueCommentEditor"
            editor-variant="editor"
            data-type="markdown"
            :data="discussion.rawMessage"
            :has-close-button="true"
            submit-btn-text="Применить"
            placeholder="Напишите комментарий здесь"
            :has-error="hasError"
            :error-text="textError"
            :close-on-unfocus="true"
            @close="hasEdit = false"
            @submit="pushComment"
            @hide="hasEdit = false"
          ></gf-custom-text-editor>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IssueS from '@shared/services/issue.service';
import GfCustomTextEditor from '@/shared-modules/shared-components/shared/GfCustomTextEditor';
import { smallNotification } from '@/shared-modules/services/gf.notification.service';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
// import RefS from '@shared/services/reference.service';

export default {
  name: 'ProjectIssueDiscussionMessage',
  components: { GfCustomTextEditor },
  props: ['discussion'],
  data() {
    return {
      hasEdit: false,
      hasDelete: false,
      hasError: false,
      textError: null,
      commentIsDeleted: false,
      hasEditPermission: false
    };
  },
  computed: {
    issue() {
      return this.$store.getters.getIssue;
    },
    getCounter() {
      return this.$store.getters.getDiscussionsCounter;
    }
  },
  mounted() {
    this.checkDeleteAccess();
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    checkDeleteAccess() {
      const token = document.querySelector('head meta[name="uuid"]');
      if (!token) return;
      const uuid = token.content;
      const aid = this.discussion.author.id;

      if (uuid === aid || this.getActionAvailabilityFlag(ACTION_ENUM.DELETE_ISSUE_NOTE)) {
        this.hasDelete = true;
      }

      if (
        uuid === this.discussion?.author?.id ||
        this.getActionAvailabilityFlag(ACTION_ENUM.EDIT_ISSUE_NOTE)
      ) {
        this.hasEditPermission = true;
      }
    },
    deleteComment(e) {
      IssueS.deleteDiscussion(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.issueId,
        this.discussion.id
      ).then((res) => {
        this.result = res;
      });

      this.commentIsDeleted = true;
      this.$store.commit('addDiscussionsCounter', this.getCounter - 1);

      setTimeout(() => {
        this.$destroy();
        this.$el.parentNode.removeChild(this.$el);
      }, 500);
    },
    editComment() {
      if (this.discussion?.rawMessage[0] === '<')
        smallNotification('danger', { title: 'Невозможно отредактировать комментарий!' });
      else this.hasEdit = true;
    },
    async pushComment(data) {
      const editedComment = await data;
      if (editedComment === undefined) return;
      if (editedComment === null || editedComment?.length === 0) {
        this.hasError = true;
        this.textError = 'Комментарий не должен быть пустым';
      } else {
        this.hasError = false;
        IssueS.editDiscussion(
          this.$route.params.alias,
          this.$route.params.projectAlias,
          this.$route.params.issueId,
          this.discussion.id,
          editedComment
        ).then((res) => {
          this.hasEdit = false;
          this.discussion.message = res?.message;
          this.discussion.rawMessage = editedComment;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.markdown-body::v-deep p:last-child {
  margin-bottom: 0;
}

.discussion__item {
  $this: '.discussion__item';

  max-height: 100000px;
  transition: 0.5s ease-out;

  &.--hidden {
    max-height: 0;
  }

  #{$this}-btn {
    padding: 0;
    width: 20px;
    font-size: 13px;
  }
}
</style>
